import type { ReplyPreview } from "@ferrivia/api-contract";
import { useTranslation } from "@ferrivia/i18n";
import s from "./ReplyQuote.module.css";

export interface ReplyQuoteProps {
  reply: ReplyPreview;
  isOwnReply: boolean;
  onClick?: () => void;
}

function snippetText(reply: ReplyPreview, redactedLabel: string): string {
  if (reply.redactedAt) return redactedLabel;
  const first = reply.body.blocks[0];
  if (first && "text" in first && typeof first.text === "string") {
    return first.text.length > 120 ? first.text.slice(0, 120) + "…" : first.text;
  }
  return "";
}

export function ReplyQuote({ reply, isOwnReply, onClick }: ReplyQuoteProps) {
  const { t } = useTranslation("chat");

  const name =
    reply.authorName ?? t("reply.unknownSender", "Tuntematon lähettäjä");
  const text = snippetText(reply, t("reply.redacted", "Viesti poistettu"));

  const className = `${s.root} ${isOwnReply ? s.own : s.other}`;
  const inner = (
    <>
      <span className={s.name}>{name}</span>
      <span className={s.text}>{text}</span>
    </>
  );

  // An outbox message's quote has nothing to jump to yet — the quoted message
  // is on screen but the reply itself has no id, so it renders inert.
  if (!onClick) {
    return <div className={className}>{inner}</div>;
  }

  return (
    <button type="button" className={`${className} ${s.clickable}`} onClick={onClick}>
      {inner}
    </button>
  );
}
